























import RemoveIcon from '@/components/AvatarBuilderUI/TraitPreviews/RemoveIcon.vue';
import { Prop, Component, Vue, Ref } from 'vue-property-decorator';
import Blizzard from '@/services/Blizzard';

@Component({
  components: {
    RemoveIcon,
  },
})
export default class HeadTraitPreview extends Vue {
  @Prop(String) readonly previewSrc: string | undefined;
  @Prop(Number) readonly itemValue: number | undefined;
  @Prop(Boolean) readonly tabNavigationEnabled: boolean | undefined;
  @Ref('trait') readonly trait: HTMLImageElement | undefined;

  get errorImage(): string {
    return require('@/assets/reload_failed.png');
  }
  onLoadEnd(): void {
    Blizzard.recordTraitPreviewLoad(false);
  }
  onError(): void {
    Blizzard.recordTraitPreviewLoad(true);
    if (this.$refs && this.trait) {
      this.trait.src = this.errorImage;
    }
  }
  onClick(): void {
    if (this.$refs && this.trait && this.itemValue !== -1 && this.trait.src === this.errorImage) {
      // retry loading all unloaded preview images in the grid when user clicks
      // on refresh icon
      this.$parent.$emit('reload-category-grid');
    } else {
      this.$emit('on-select-option');
    }
  }
}
